import FunctionList from './FunctionList';
import { mapMutations } from 'vuex';
import { getCategoryByGroupType, getProduct } from '@/api/modules/product';
export default {
  name: 'function',
  components: {
    FunctionList
  },
  data() {
    return {
      categoryList: [],
      activedIndex: '',
      list: [],
      loading: false
    };
  },
  created() {
    this.getType();
  },
  methods: {
    handleClickCatagory(item) {
      this.activedIndex = item.group_code;
      this.getList();
    },
    ...mapMutations({
      setcode: 'app/setcode'
    }),
    // 获取分类
    async getType() {
      await getCategoryByGroupType({
        group_type: 'component'
      }).then(res => {
        if (res.code === 1) {
          var _res$result$;
          this.activedIndex = (_res$result$ = res.result[0]) === null || _res$result$ === void 0 ? void 0 : _res$result$.group_code;
          this.setcode(this.activedIndex);
          this.categoryList = res.result;
          this.getList();
        }
      });
    },
    // 获取分类list
    async getList() {
      this.loading = true;
      await getProduct({
        group_code: this.activedIndex
      }).then(res => {
        if (res.code === 1) {
          this.loading = false;
          this.list = res.result;
        }
      });
    }
  }
};